import Modal from 'react-modal';
import api from '../../../../config';
import { toast } from 'react-toastify';
import './index.css';
import { showMessageError } from '../../../../classes/functions';

export default function ModalReverseAproveSeparation({customStyles, modalReverseAproveSeparation, setModalReverseAproveSeparation, id, setCarrying, setStatus, API, APIBody, APIMethod}){
    function reverseAprove() {
        setCarrying(true);

        api[APIMethod](API, APIBody !== '' && APIBody)
        .then((response) => {
          if(response?.data?.row?.status){
            setStatus(response?.data?.row?.status);
          }

          toast.success('Estornado com Sucesso.');
          setModalReverseAproveSeparation(false);
          setCarrying(false);
        }).catch((error) => {
          setCarrying(false);
          showMessageError(error.response.data);
        });
      }

    return (
        <Modal 
            isOpen={modalReverseAproveSeparation} 
            onRequestClose={() => setModalReverseAproveSeparation(false)} 
            contentLabel="Estornar Separação" 
            className="reverse-aprove-modal"
            overlayClassName="modal-overlay"
            ariaHideApp={false}>
            <div className="body-modal">
              <div className="divGroup">
                <h3>Deseja realmente estornar a aprovação?</h3>
              </div>
              <div className="formDiv">
                <button type="button" className="buttonSubmit" onClick={reverseAprove}>Confirmar</button>
                <button type="button" className="buttonCancel" onClick={() => setModalReverseAproveSeparation(false)}>Fechar</button>
              </div>
            </div>
        </Modal>
    )
}